<template>
    <div>
        <!-- Home Section -->
        <section id="home">
            <section id="xslider" class="contain">
                <div class="txp-banner">
                    <img src="/assets/images/booking.png" alt="slidebg1" data-bgfit="cover"
                        data-bgposition="left top" data-bgrepeat="no-repeat" style=" width: 100%;">
                </div>
            </section>
        </section>

        <section id="aa" class="contain ">
            <div class="inner">
                <div class="header ">
                    <span>Booking Prices & Validity:</span>
                </div>

                <div class="page-desc">
                    <p>
                        We are excited to extend a special accommodation rate to you for your stay at the luxurious Nobu Hotel London Portman Square. To secure your booking, kindly contact the hotel directly at reserve-portmansquare@nobuhotels.com
                        and use the code ALLOCEFG24.
                    </p>
                </div>
                <div class="header ">
                    <span>Booking Prices and Validity:</span>
                </div>

                <div class="page-desc">
                    <p>
                        This exclusive rate is applicable for room reservations between September 8th and September 12th, 2024. As availability is limited, we recommend booking your stay at your earliest convenience. The special room rate for single occupancy is GBP 395 per night, which includes VAT and breakfast. Please be aware that an additional charge of £25 per night will apply if you wish to accommodate an extra guest in the room. If you would like more information about other different room types offered by the hotel, please email them at reserve-portmansquare@nobuhotels.com.
                    </p>
                </div>
                <div class="header ">
                    <span>Cancellation Policy:</span>
                </div>

                <div class="page-desc">
                    <p>
                        Concerning room cancellations, please note that all bookings are made directly through the Hotel, and EFG Hermes is not responsible for any changes or cancellations. Kindly note that reservations must be canceled by August 8th to avoid charges for the entire room stay.
                    </p>
                </div>
            </div>
            <!-- End inner div -->
        </section>
    </div>
</template>

<script>
export default {
    data: () => ({
        screenHeight: window.innerHeight + "px",
    }),
};
</script>
